export default __webpack_public_path__ + "static/media/sync.798b3045.svg";